var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerySatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_955_3533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 60,
    height: 60,
    rx: 12,
    fill: "#55A630"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 28C42.6569 28 44 26.6569 44 25C44 23.3431 42.6569 22 41 22C39.3431 22 38 23.3431 38 25C38 26.6569 39.3431 28 41 28Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 28C28.6569 28 30 26.6569 30 25C30 23.3431 28.6569 22 27 22C25.3431 22 24 23.3431 24 25C24 26.6569 25.3431 28 27 28Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.98 10C22.94 10 14 18.96 14 30C14 41.04 22.94 50 33.98 50C45.04 50 54 41.04 54 30C54 18.96 45.04 10 33.98 10ZM34 46C25.16 46 18 38.84 18 30C18 21.16 25.16 14 34 14C42.84 14 50 21.16 50 30C50 38.84 42.84 46 34 46ZM24 34C25.56 38.68 29.44 42 34 42C38.56 42 42.44 38.68 44 34H24Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_955_3533",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_955_3533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_955_3533",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerySatisfied);
export default __webpack_public_path__ + "static/media/very_satisfied.edd11223.svg";
export { ForwardRef as ReactComponent };